module.exports = "/packs/media/modules/welcome/assets/roadmap-9c233bf2918a60f04eba8cac5b6dcaeb.jpg";